import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import FullCalendar, { isPropsEqual } from "@fullcalendar/react";
import FormNuevaCita from "./FormNuevaCita";
import daygridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin from '@fullcalendar/interaction';
import { leadingZero, getHoraCita, getAmpm } from "../../../resources/Helper";
import AgendaTooltip from "../custom/AgendaTooltip";

function AgendaProfesional(props) {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [citas, setCitas] = useState([]);
    const [toastMsg, setToastMsg] = useState();
    const [nombreUsuario, setNombreUsuario] = useState('');
    const [permisos, setPermisos] = useState([]);

    /////////////////////////////////

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [modalState, setModalState] = useState('hidden');
    const [extendedProps, setExtendedProps] = useState({});

    const [idCita, setIdCita] = useState('');
    const [idUsuarioAgendamiento, setIdUsuarioAgendamiento] = useState('');
    const [idPaciente, setIdPaciente] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [duracionCita, setDuracionCita] = useState('');
    const [estadoCita, setEstadoCita] = useState('');
    const [idEstadoCita, setIdEstadoCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [verCita, setVerCita] = useState(false);
    const [puedeAtender, setPuedeAtender] = useState('');
    const [stepCita, setStepCita] = useState('');

    const [horaAtencionCita, setHoraAtencionCita] = useState();
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();

    const [slotDuration, setSlotDuration] = useState('00:30:00');
    
    const [tooltipTop, setTooltipTop] = useState();
    const [tooltipLeft, setTooltipLeft] = useState();
    const [tooltipDisplay, setTooltipDisplay] = useState();
    const [contenidoTooltip, setContenidoTooltip] = useState('');

    /////////////////////////////////

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setPermisos(userdata.up);
            setStepCita(userdata.step);
            setSlotDuration("00:"+userdata.step+":00");
        }

        if (localStorage.getItem('proximaCita')) {
            
            const proximaCita = JSON.parse(localStorage.getItem('proximaCita'));

            setIdUsuarioAgendamiento(proximaCita.id_profesional);
            setNombreUsuario(proximaCita.nombre_profesional);
            setIdPaciente(proximaCita.id_paciente);
            setPrimerNombre(proximaCita.primer_nombre);
            setSegundoNombre(proximaCita.segundo_nombre);
            setPrimerApellido(proximaCita.primer_apellido);
            setSegundoApellido(proximaCita.segundo_apellido);
            setEmail(proximaCita.email);
            setCelular(proximaCita.celular);
            setTipoDocumento(proximaCita.tipo_documento);
            setNumeroDocumento(proximaCita.numero_documento);

            localStorage.removeItem('proximaCita');
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: idUsuarioAgendamiento
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                setLoggedIn(false);
            });
    },[]);



    useEffect(() => {
        getCitas();
    },[idUsuarioAgendamiento]);



    const getCitas = () => {

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: idUsuarioAgendamiento
            }
        }

        axios.get('/citas-profesional',config2)
            .then(response => {
                if (response.status===200) {
                    setCitas(response.data);
                }
            })
            .catch(error => console.log(error.response.data))
    }


    const calendarClick = (info) => {
        
        if (permisos.includes('crearCitas')) {
            const fechaISO = new Date(info.dateStr);
            const fechaCita = fechaISO.getFullYear()+'-'+leadingZero(fechaISO.getMonth()+1)+'-'+leadingZero(fechaISO.getDate());
            const horaCita = leadingZero(fechaISO.getHours())+':'+leadingZero(fechaISO.getMinutes())+':00';

            setDate(fechaCita);
            setTime(horaCita);
            setExtendedProps(null);

            setHoraAtencionCita(getHoraCita(fechaISO.getHours()));
            setMinutoCita(leadingZero(fechaISO.getMinutes()));
            setAmpmCita(getAmpm(fechaISO.getHours()));

            setDuracionCita('');
            setEstadoCita('');
            setIdEstadoCita('');
            setUnidadAtencion('');
            setMotivoConsulta('');
            setVerCita(false);

            setModalState('visible');
        }
    }


    function handleMouseEnter(info) {
        
        let np = info.event.extendedProps.segundo_nombre ? info.event.extendedProps.primer_nombre+" "+info.event.extendedProps.segundo_nombre : info.event.extendedProps.primer_nombre;
        let ap = info.event.extendedProps.primer_apellido+" "+info.event.extendedProps.segundo_apellido;

        let bodyRect = document.body.getBoundingClientRect();
        let elemRect = info.el.getBoundingClientRect();
        let offsetLeft = elemRect.left - bodyRect.left;
        let elementHeight = elemRect.height;
        let offsetTop = elemRect.top + elementHeight + 15 - bodyRect.top;

        const contenidott =    `<p><strong>Paciente: </strong>${np} ${ap}</p>
                                <p><strong>No. documento: </strong>${info.event.extendedProps.numero_documento}</p>
                                <p><strong>Estado de la cita: </strong>${info.event.extendedProps.estado_cita}</p>
                                <p><strong>Motivo consulta: </strong>${info.event.extendedProps.motivo_consulta}</p>
                                <p><strong>Celular: </strong>${info.event.extendedProps.celular}</p>
                                <p><strong>E-mail: </strong>${info.event.extendedProps.email}</p>`;

        setContenidoTooltip(contenidott);

        setTooltipTop(offsetTop+'px');
        setTooltipLeft(offsetLeft+'px');
        setTooltipDisplay('block');
    }

    function handleMouseLeave(info) {

        setTooltipDisplay('');
    }


    return <>
                <div className="hold-transition">
                    <Header client={client} />
                    <Aside client={client} />
                    
                    <div className={'content-wrapper'}>
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-6">
                                        <h1 className="m-0">Agenda {nombreUsuario}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="content">
                            <div className="container-fluid">

                            <FullCalendar 
                                    plugins={[daygridPlugin,timeGridPlugin,interactionPlugin]} 
                                    initialView="timeGridWeek"
                                    locale={esLocale}
                                    allDaySlot={false}
                                    headerToolbar={{
                                                        left: 'prev,next today', 
                                                        center: 'title', 
                                                        right: 'dayGridMonth,timeGridWeek,timeGridDay'
                                                    }}

                                    dateClick={calendarClick}
                                    events={citas}
                                    /*eventClick={clicCita}
                                    editable={true}
                                    eventDrop={handleCitaDrop}*/
                                    
                                    eventMouseEnter={handleMouseEnter}
                                    eventMouseLeave={handleMouseLeave}

                                    //eventDragStart={() => setTooltipDisplay('none')}
                                    
                                    eventOverlap={false}
                                    //ref={calendarRef}
                                    slotDuration={slotDuration}

                                    slotLabelInterval={slotDuration}

                                    slotLabelFormat={{
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        omitZeroMinute: false,
                                        meridiem: 'short',
                                        hour12: true
                                      }}

                                    
                                    >

                            </FullCalendar>

                            <FormNuevaCita 
                                modalState={modalState} 
                                closeModal={() => setModalState('hidden')} 
                                profesionalAsignado={idUsuarioAgendamiento}
                                nombreProfesionalAsignado={nombreUsuario}
                                usuarioAsigna={idUsuarioAgendamiento}
                                nombreUsuarioAsigna={nombreUsuario}
                                fecha={date}
                                hora={time}
                                //reloadCitas={getCitas}
                                reloadCitasAgenda={getCitas}
                                //extendedProps={extendedProps}
                                //idPacienteExistente={idPaciente}
                                primerNombre={primerNombre}
                                segundoNombre={segundoNombre}
                                primerApellido={primerApellido}
                                segundoApellido={segundoApellido}
                                email={email}
                                celular={celular}
                                tipoDocumento={tipoDocumento}
                                numeroDocumento={numeroDocumento}
                                //duracionCita={duracionCita}
                                //estadoCita={idEstadoCita}
                                //unidadAtencion={unidadAtencion}
                                //motivoConsulta={motivoConsulta}
                                verCita={false}
                                puedeAtender={true}
                                //idPaciente={idPaciente}
                                primeraVez={true}
                                
                                horaAtencionCita={horaAtencionCita}
                                minutoCita={minutoCita}
                                ampmCita={ampmCita}

                                agendarCitaPaciente={idPaciente}

                                bloquearEstadoCita={true}
                                bloquearPaciente={true}
                                bloquearProfesional={true}

                                stepCita={stepCita}

                                estadoPorDefecto={'asignada'}
                            />

                            <AgendaTooltip top={tooltipTop} left={tooltipLeft} display={tooltipDisplay} contenido={contenidoTooltip} />
                                
                            </div>
                        </section>
                    </div>
                    
                    

                    <Footer showToast={false} delay={0} message={toastMsg} />
                </div>
            </>
}
export default AgendaProfesional;